window.Vue = require('vue');
window.Vue.config.productionTip = false;

window.axios = require('axios');
window.axios.defaults.headers.common['Accept'] = 'application/json';
window.axios.defaults.headers.common['Content-Type'] = 'application/json';
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.scrollToErrors = new (require('./components/scroll-to'));



// WEBPACK FOOTER //
// ./web/app/themes/giles/resources/js/bootstrap.js